import React from 'react';
import { ListRenderItem } from 'react-native';

import Container from '@src/components/Container';
import PostCard from '@src/components/PostCard';
import RefreshControl from '@src/components/RefreshControl';
import Card from '@src/components/TourSummeryCard';
import VisibleStatusBar from '@src/components/VisibleStatusBar';
import useAnimatedHeader from '@src/hooks/useAnimatedHeader';
import useViewableItems from '@src/hooks/useViewableItems';
import { Post, TourSummery } from '@src/types';

import ListHeaderComponent from './ListHeaderComponent';
import { ContentWrapper, List } from './styled';
import { AllCollections, Props } from './types';
import useCollection from './useCollection';
import useCollectionPosts from './useCollectionPosts';
import useCollectionTours from './useCollectionTours';

const Screen: React.FC<Props> = ({ route }) => {
  const handleScroll = useAnimatedHeader();
  const collection = useCollection(route.params.id);
  const {
    data: postsData,
    handleEndReached: handlePostsEndReached,
    handleRefresh: handlePostsRefresh,
    refreshing: postsRefreshing,
  } = useCollectionPosts(collection?.id, collection?.posts);

  const {
    data: toursData,
    handleEndReached: handleToursEndReached,
    handleRefresh: handleToursRefresh,
    refreshing: toursRefreshing,
  } = useCollectionTours(collection?.id, collection?.tours);

  const allData = React.useMemo(() => [...toursData, ...postsData], [
    postsData,
    toursData,
  ]);

  const {
    handleViewableItemsChanged,
    currentVisibleIndex,
    viewabilityConfig,
  } = useViewableItems();

  const handleEndReached = React.useCallback(async () => {
    await handlePostsEndReached();
    await handleToursEndReached();
  }, [handlePostsEndReached, handleToursEndReached]);

  const handleRefresh = React.useCallback(async () => {
    await handlePostsRefresh();
    await handleToursRefresh();
  }, [handlePostsRefresh, handleToursRefresh]);

  const refreshing = React.useMemo(() => toursRefreshing || postsRefreshing, [
    postsRefreshing,
    toursRefreshing,
  ]);

  const renderItem: ListRenderItem<AllCollections> = React.useCallback(
    ({ item, index }) => {
      if ((item as Post).content !== undefined) {
        return (
          <PostCard data={item as Post} play={currentVisibleIndex === index} />
        );
      } else if ((item as TourSummery).booking !== undefined) {
        return (
          <ContentWrapper>
            <Card item={item as TourSummery} />
          </ContentWrapper>
        );
      } else {
        return null;
      }
    },
    [currentVisibleIndex]
  );
  console.log('collections', collection, allData);
  return (
    <>
      <VisibleStatusBar />
      <Container>
        <List
          data={allData}
          ListHeaderComponent={<ListHeaderComponent collection={collection} />}
          refreshControl={
            <RefreshControl refreshing={refreshing} onRefresh={handleRefresh} />
          }
          onViewableItemsChanged={handleViewableItemsChanged}
          viewabilityConfig={viewabilityConfig}
          onScroll={handleScroll}
          onEndReached={handleEndReached}
          renderItem={renderItem}
        />
      </Container>
    </>
  );
};

Screen.displayName = 'Collection';

export default Screen;
